import React from 'react';
import { Helmet } from 'react-helmet-async';
import bagshotOfficesOutside from '../../assets/images/bagshot-offices-outside.webp';
import unit1Img from '../../assets/images/Unit 1 Nov16_2r.webp';
import unit2Img from '../../assets/images/Unit 2 Nov16 _1r.webp';
import unit3Img from '../../assets/images/unit-3.webp';
import unit4Img from '../../assets/images/unit-4.webp';
import unit5Img from '../../assets/images/unit-5.webp';
import units4And5Img from '../../assets/images/units-4-and-5.webp';
import unit6Img from '../../assets/images/Office 6.webp';
import unit7And8Img from '../../assets/images/Office 7 & 8.webp';
import offices678Img from '../../assets/images/Offices 6,7 & 8.webp';
import kitchenImg from '../../assets/images/Kitchen Nov16r.webp';
import meetingImg from '../../assets/images/Meeting Nov16_2r.webp';
import showerImg from '../../assets/images/Shower 18.webp';
import closetImg from '../../assets/images/Closet 18.webp';
import './Gallery.css';

export const Gallery: React.FC = () => {
  const galleryItems = [
    { id: 'exterior', name: 'Building Exterior', image: bagshotOfficesOutside, description: 'Exterior view of Bagshot Offices in the centre of town' },
    { id: 'unit-1', name: 'Unit 1', image: unit1Img, description: 'Bright private office unit' },
    { id: 'unit-2', name: 'Unit 2', image: unit2Img, description: 'Modern workspace' },
    { id: 'unit-3', name: 'Unit 3', image: unit3Img, description: 'Quiet, well-insulated office room' },
    { id: 'unit-4', name: 'Unit 4', image: unit4Img, description: 'Compact and functional office unit' },
    { id: 'unit-5', name: 'Unit 5', image: unit5Img, description: 'Private office space ready for business' },
    { id: 'units-4-5', name: 'Units 4 & 5', image: units4And5Img, description: 'Combined office suite for larger teams' },
    { id: 'unit-6', name: 'Unit 6', image: unit6Img, description: 'Private office unit overlooking the square' },
    { id: 'units-7-8', name: 'Units 7 & 8', image: unit7And8Img, description: 'Spacious combined office configuration' },
    { id: 'offices-6-7-8', name: 'Offices 6, 7 & 8', image: offices678Img, description: 'Overview showing offices 6, 7 & 8' },
    { id: 'kitchen', name: 'Communal Kitchen', image: kitchenImg, description: 'Fully equipped kitchen with high-end appliances' },
    { id: 'kitchen-area', name: 'Kitchen Seating Area', image: meetingImg, description: 'Relaxation and seating space within the kitchen' },
    { id: 'shower', name: 'Bathroom & Shower', image: showerImg, description: 'Modern bathroom facility including a shower' },
    { id: 'closet', name: 'Second Bathroom', image: closetImg, description: 'Second bathroom with a toilet' },
  ];

  return (
    <div className="gallery-container">
      <Helmet>
        <title>Gallery | Small Offices to Rent in Bagshot</title>
        <meta name="description" content="View photos of our high-specification small office units to let in Bagshot, including individual units, kitchen, meeting areas, and facilities." />
        <link rel="canonical" href="https://www.bagshot-offices.co.uk/gallery" />
      </Helmet>
      
      <h1 className="gallery-title">Office Gallery</h1>
      <p className="gallery-intro">
        Browse photos of our high-specification small office units, kitchen, and facilities to rent in Bagshot.
      </p>

      <div className="gallery-grid">
        {galleryItems.map((item) => (
          <div key={item.id} className="gallery-card">
            {item.image ? (
              <div className="gallery-image-container">
                <img src={item.image} alt={item.name} className="gallery-image" />
              </div>
            ) : (
              <div className="image-placeholder">
                <span>Image Coming Soon</span>
              </div>
            )}
            <div className="gallery-card-content">
              <h3>{item.name}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
